module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "cummins_banner_desktop.84d2639b.svg";